import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import _ from 'underscore';

import { Shipment } from 'services/action';

import { Form } from 'ui/components';
import { Select } from 'ui/components';

const initialState = {
  privilege: null,
  isShow: false,
  errorItems: null,
  dividers: 4000,
  items: [
    {
      item_code: '',
      item_name: '',
      quantity: '',
      weight: '',
      long: '',
      Wide: '',
      high: '',
      metric: '',
      quantity_delivered: '',
      unit_price: ''
    },
  ],
};

const options = [
  { value: 'Aerospace Material', label: 'Aerospace Material' },
  {
    value: 'Hasil Pertanian / Buah / Sayuran',
    label: 'Hasil Pertanian / Buah / Sayuran',
  },
  {
    value: 'Hasil Peternakan / Daging / Ikan',
    label: 'Hasil Peternakan / Daging / Ikan',
  },
  {
    value: 'Otomotif / Sparepart / Mekanikal',
    label: 'Otomotif / Sparepart / Mekanikal',
  },
  { value: 'FMCG / Consumer Goods', label: 'FMCG / Consumer Goods' },
  {
    value: 'Peralatan Berat / Industrial',
    label: 'Peralatan Berat / Industrial',
  },
  { value: 'Oil & Gas / Bahan Kimia', label: 'Oil & Gas / Bahan Kimia' },
  { value: 'Furniture', label: 'Furniture' },
  { value: 'Constructions Material', label: 'Constructions Material' },
  { value: 'Obat-obatan / Healthcare', label: 'Obat-obatan / Healthcare' },
  { value: 'Peralatan Medis', label: 'Peralatan Medis' },
  { value: 'Elektronik', label: 'Elektronik' },
  { value: 'Lain-lain', label: 'Lain-lain' },
];

const UpdateItems = ({ data, onClose, serviceType }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [{ isShow, errorItems, dividers, items }, setState] =
    React.useState(initialState);

  const clearState = () => {
    setState({ ...initialState });
  };

  const $handleClose = () => {
    clearState();
  };

  const $handleItemsChange = async (i, e) => {
    let newItems = [...items];

    if (e) {
      if (e?.target) {
        newItems[i][e?.target.name] = e.target.valueNumber
          ? e.target.valueNumber
          : e.target.value;
      } else {
        newItems[i]['item'] = e;
        newItems[i]['item_name'] = e.value;
      }
    } else {
      newItems[i]['item'] = null;
      newItems[i]['item_name'] = '';
    }

    if (newItems[i]['long'] && newItems[i]['Wide'] && newItems[i]['high']) {
      const m =
        ((parseFloat(newItems[i]['long']) *
          parseFloat(newItems[i]['Wide']) *
          parseFloat(newItems[i]['high'])) /
          dividers);

      newItems[i]['metric'] = m?.toFixed(2);
    } else {
      newItems[i]['metric'] = null;
    }

    setState((prevState) => ({ ...prevState, items: newItems }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      items: [
        ...items,
        {
          itemOption: null,
          quantity: '',
          weight: '',
          long: null,
          Wide: null,
          high: null,
          metric: null,
          quantity_delivered: null,
          unit_price: null
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newItems = [...items];
    newItems.splice(i, 1);
    setState((prevState) => ({ ...prevState, items: newItems }));
  };

  const $onSubmit = async (e) => {
    const payload = {
      action: 'items',
    };

    let newItem = [];
    let update = true;

    if (items) {
      items.forEach((item) => {
        if (
          item?.item_name &&
          item?.quantity &&
          (item?.weight || item?.metric)
        ) {
          newItem.push({
            item_code: item?.item_code,
            item_name: item?.item_name,
            quantity: parseFloat(item?.quantity),
            weight: parseFloat(item?.weight),
            long: item?.long ? parseFloat(item?.long) : null,
            Wide: item?.Wide ? parseFloat(item?.Wide) : null,
            high: item?.high ? parseFloat(item?.high) : null,
            metric: item?.metric ? parseFloat(item?.metric) : null,
            quantity_delivered: item?.quantity_delivered ? parseFloat(item?.quantity_delivered) : null,
            unit_price: item?.unit_price ? parseFloat(item?.unit_price) : null,
          });
        }
      });

      payload.items = newItem;
    }

    if (data?.shipment?.type === 'ltl') {
      if (newItem?.length === 0) {
        update = false
        setState((prevState) => ({ ...prevState, errorItems: true }));
      }
    }

    setTimeout(function () {
      setState((prevState) => ({ ...prevState, errorItems: false }));
    }, 3000);

    if (update) {
      const req = await Dispatch(Shipment.$updatePartial(data?.id, payload));

      if (req?.message === 'success') {
        onClose();
        $handleClose();
      }
    }
  };

  React.useEffect(() => {
    if (!isShow) return;

    if (data?.shipment?.items) {
      let items = [];
      data?.shipment?.items?.forEach((item) => {
        let option = null;
        // ini penanda bahwa tidak ada optisnnya
        let keyOptions = -1;

        _.each(options, function (i, key) {
          if (i?.value === item.item_name) {
            keyOptions = key;
            return;
          }
        });

        if (keyOptions >= 0) {
          option = options[keyOptions];
        } else {
          option = { value: item.item_name, label: item.item_name };
          options.push(option);
        }

        items.push({
          item: option,
          item_code: item?.item_code,
          item_name: item?.item_name,
          quantity: parseFloat(item?.quantity),
          weight: parseFloat(item?.weight),
          long: item?.long ? parseFloat(item?.long) : null,
          Wide: item?.Wide ? parseFloat(item?.Wide) : null,
          high: item?.high ? parseFloat(item?.high) : null,
          metric: item?.m3 ? parseFloat(item?.m3) : null,
          quantity_delivered: item?.quantity_delivered ? parseFloat(item?.quantity_delivered) : null,
          unit_price: item?.unit_price ? parseFloat(item?.unit_price) : null,
        });
      });
      setState((prevState) => ({ ...prevState, dividers: data?.order?.service_type?.dividers, items: items }));
    }
  }, [isShow]);

  return (
    <div>
      <div
        className="dropdown-item d-flex align-items-center cursor-pointer"
        onClick={() => {
          setState((prevState) => ({ ...prevState, isShow: true }));
        }}
      >
        <Fi.FiEdit size={15} color="#202020" className="me-2" />
        Perbaharui Item
      </div>

      <Modal
        show={isShow}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="lg"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose}></div>
          <div className="text-center fs-6 mb-3">
            Perbaharui Item <b>{data?.code}</b>
          </div>
          <div className="border">
            {items?.map((e, i) => (
              <div
                className={cn('row align-items-end border-bottom py-3 m-0')}
                key={i}
              >
                <div className="col-11">
                  <div className="row ">
                    <div
                      className={cn(
                        data?.order?.service_type?.dividers > 0
                          ? 'col-md-3 pe-md-0'
                          : 'col-md-6 pe-md-0'
                      )}
                    >
                      <label className={`form-label ${data?.shipment?.type === "ltl" ? 'required' : ''}`}>Komoditas</label>
                      <Select.Createable
                        isClearable
                        placeholder=""
                        classNamePrefix={errorItems ? 'is-invalid' : 'select'}
                        value={e?.item}
                        options={options}
                        name="item_name"
                        onChange={(e) => $handleItemsChange(i, e)}
                        error={errorItems}
                      />
                    </div>
                    <div
                      className={cn(
                        data?.order?.service_type?.dividers > 0
                          ? 'col-md-2 pe-md-0'
                          : 'col-md-3 pe-md-0'
                      )}
                    >
                      <Form.Input
                        required={data?.shipment?.type === "ltl" ? true : false}
                        label="Koli"
                        name="quantity"
                        type="number"
                        value={e?.quantity}
                        onChange={(e) => $handleItemsChange(i, e)}
                        error={errorItems}
                      />
                    </div>
                    <div
                      className={cn(
                        data?.order?.service_type?.dividers > 0
                          ? 'col-md-2'
                          : 'col-md-3'
                      )}
                    >
                      <Form.Input
                        required={data?.shipment?.type === "ltl" ? true : false}
                        label="Berat (Kg)"
                        name="weight"
                        type="text"
                        value={e?.weight}
                        onChange={(e) => $handleItemsChange(i, e)}
                        error={errorItems}
                      />
                    </div>

                    {data?.order?.service_type?.dividers > 0 && (
                      <>
                        <div className="col-md-3">
                          <div className="row ">
                            <label className="form-label fs-8 ms-md-n2">
                              Dimensi (P x L x T) (cm)
                            </label>
                            <div className="col-4 p-md-0 pe-0">
                              <Form.Input
                                className="rounded-start rounded-0"
                                autoComplete="off"
                                pattern="[0-9]{0,50}"
                                name="long"
                                type="number"
                                value={e?.long}
                                onChange={(e) => $handleItemsChange(i, e)}
                              />
                            </div>
                            <div className="col-4 p-0">
                              <Form.Input
                                className="rounded-0"
                                autoComplete="off"
                                pattern="[0-9]{0,50}"
                                type="number"
                                name="Wide"
                                value={e?.Wide}
                                onChange={(e) => $handleItemsChange(i, e)}
                              />
                            </div>
                            <div className="col-4 p-md-0 ps-0">
                              <Form.Input
                                className="rounded-end rounded-0"
                                autoComplete="off"
                                pattern="[0-9]{0,50}"
                                name="high"
                                type="number"
                                value={e?.high}
                                onChange={(e) => $handleItemsChange(i, e)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-2 pe-md-0">
                          <Form.Input
                            autoComplete="off"
                            pattern="[0-9]{0,50}"
                            label="Volumetrik (Kg)"
                            name="metric"
                            type="number"
                            disabled
                            value={e?.metric}
                            onChange={(e) => $handleItemsChange(i, e)}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="col-1">
                  {i ? (
                    <button
                      type="button"
                      className="btn btn-danger rounded p-2 mb-3"
                      style={{ minHeight: 36, minWidth: '100%' }}
                      onClick={() => $removeField(i)}
                    >
                      <Fi.FiX />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary rounded p-2 mb-3"
                      style={{ minHeight: 36, minWidth: '100%' }}
                      onClick={() => $addMoreFields()}
                    >
                      <Fi.FiPlus />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
            onClick={$onSubmit}
            disabled={StateForm?.loading}
          >
            Simpan Perubahan
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UpdateItems;
